/**
* SEO Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'seo-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.seo-cards__slider' ).length ) {
        $( '.seo-cards__slider' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            perPage: 4,
            focus: 'center',
            perMove: 1,
            gap: '20px',
            arrows: true,
            pagination: false,
            breakpoints: {
              640: {
                perPage: 1,
              },
              768: {
                perPage: 2,
              },
              1024: {
                perPage: 3,
              },
            },
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-cards', COMPONENT );
} )( app );
